/**
 * Иконка админ-панели в менюбаре для пользователей с ролью admin.
 * Роль запрашивается с сервера (/api/auth/me перепроверяет БД) — не из JWT.
 * План: docs/plans/2026-08-24-admin-icon.md
 */
(function () {
  'use strict';

  var ADMIN_URL = '/admin.html';
  var SHIELD_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">' +
    '<path stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" ' +
    'd="M12 2 4.5 5v6c0 4.69 3.13 8.86 7.5 10.5C16.37 19.86 19.5 15.69 19.5 11V5L12 2Z"/>' +
    '<path stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" ' +
    'd="m9.2 11.8 2 2 3.6-4"/></svg>';

  function getToken() {
    try { return localStorage.getItem('goszemlya_web_token'); } catch (e) { return null; }
  }

  function insertIcon() {
    if (document.getElementById('menu-admin-btn')) return true;
    var profile = document.getElementById('menu-profile-btn');
    if (!profile) return false;
    var a = document.createElement('a');
    a.className = 'menu-item';
    a.id = 'menu-admin-btn';
    a.href = ADMIN_URL;
    a.target = '_blank';
    a.rel = 'noopener';
    a.setAttribute('aria-label', 'Админ-панель');
    a.title = 'Админ-панель';
    a.innerHTML = SHIELD_SVG;
    profile.parentNode.insertBefore(a, profile);
    return true;
  }

  function init() {
    var token = getToken();
    if (!token) return;
    fetch('/api/auth/me', { headers: { Authorization: 'Bearer ' + token } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d || !d.user || d.user.role !== 'admin') return;
        // Администратор: раскрыть функционал, помеченный data-admin-only
        document.documentElement.classList.add('is-admin');
        document.querySelectorAll('[data-admin-only]').forEach(function (el) {
          el.style.display = '';
        });
        if (!insertIcon()) {
          // менюбар ещё не отрендерился — дождаться
          var tries = 0;
          var t = setInterval(function () {
            if (insertIcon() || ++tries > 40) clearInterval(t);
          }, 100);
        }
      })
      .catch(function () { /* тихо: иконка необязательна */ });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Пользователь мог войти ПОСЛЕ загрузки страницы — перепроверяем при логине/логауте
  window.addEventListener('auth:change', function (e) {
    if (e.detail && e.detail.authenticated) init();
    else {
      var el = document.getElementById('menu-admin-btn');
      if (el) el.remove();
      document.documentElement.classList.remove('is-admin');
      document.querySelectorAll('[data-admin-only]').forEach(function (el) {
        el.style.display = 'none';
      });
    }
  });
})();
